import { render, staticRenderFns } from "./BalanceHistory.vue?vue&type=template&id=31560d66&"
import script from "./BalanceHistory.vue?vue&type=script&lang=js&"
export * from "./BalanceHistory.vue?vue&type=script&lang=js&"
import style0 from "./BalanceHistory.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports